<template>
    <div>
        <div class="map-container">
            <map-app />
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .map-container {
        position: absolute;
        top: 0px;
        left: 0;
        right: 0;
        bottom: 0;
    }
</style>

<script>
    import MapApp from '@/components/map/MapApp.vue';

    export default {
        components: {
            'map-app': MapApp,
        }
    }
</script>